import React from 'react';

import { TextButton } from '@components/Button/variants';
import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, ContentType, click } from '@tracking';

interface ViewAllLinkProps {
  className: string;
  link: string;
  networkId: number;
  text: string;
}

const ViewAllLink = ({ className, link, networkId, text }: ViewAllLinkProps) => {
  const { trackEvent } = useEventTracking();

  const handleViewAllClick = () => {
    trackEvent(
      click({
        clickTarget: ClickTarget.AnchorLink,
        clickText: text,
        contentType: ContentType.TITVNetwork,
        contentId: networkId,
      })
    );
  };

  return (
    <TextButton as="link" className={className} href={link} onClickCapture={handleViewAllClick}>
      {text}
    </TextButton>
  );
};

export default ViewAllLink;
